import type { ReactNode } from "react";
import { AlertCircle, AlertTriangle } from "lucide-react";

export function FieldIcon({ children }: { children: ReactNode }) {
	return <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">{children}</span>;
}

export function AuthError({ message }: { message: string | null }) {
	if (!message) return null;

	return (
		<div className="mb-5 flex gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm leading-6 text-red-700">
			<AlertCircle className="mt-0.5 size-4 shrink-0" />
			<span>{message}</span>
		</div>
	);
}

export function AuthNotice({ message }: { message: string | null }) {
	if (!message) return null;

	return <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm leading-6 text-emerald-800">{message}</div>;
}

export function AuthAccessDenied() {
	return (
		<div
			role="alert"
			className="flex gap-3 rounded-lg border border-ss-yellow/60 bg-ss-yellow/15 px-4 py-3 text-sm text-slate-900"
		>
			<AlertTriangle className="mt-0.5 size-4 shrink-0 text-slate-700" />
			<div>
				<p className="font-semibold">Access denied</p>
				<p className="mt-0.5 leading-5 text-slate-700">Your organisation does not currently have access to StudyStash</p>
			</div>
		</div>
	);
}
